// extracted by mini-css-extract-plugin
export default {"MoveClassToRing":"MoveClassToRing_MoveClassToRing__Glhop","title":"MoveClassToRing_title__TqwLI","actions":"MoveClassToRing_actions__J0nLQ"};